import * as React from "react";

import { Box } from "mpulse-design-system";
import { alpha, styled } from "@mui/material";

const PopupLayout = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

const StyledBox = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  position: "fixed",
  minHeight: "100%",
  minWidth: "100%",
  display: "flex",
  justifyContent: "center",
  padding: `${theme.spacing(8)} 0`,
  background: alpha("#000", 0.45),
  overflow: "auto",
  margin: "auto",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}));

export default PopupLayout;
